{
  "favorites_title": "Favorites",
  "favorites_empty": "The list is empty",
  "favorites_hidden_guests": "You have {{count}} hidden guest bookmarks.",
  "favorites_premium_required": "Available with active Premium",
  "favorites": {
    "warning_inactive": "Hasn't logged in for more than {{days}} days",
    "warning_registered": "Nickname is registered"
  },
  "privacy_settings": "Privacy settings",
  "private_messages_privacy": "Private messages",
  "privacy_allow_all": "Allow all",
  "privacy_favorites_only": "Only from favorites",
  "privacy_disabled": "Disable completely",
  "private_messages_reset_notification": "Premium has expired. Private message settings have been reset to \"Allow all\"",
  "add_favorite_guest_warning_title": "Adding a guest",
  "add_favorite_guest_warning_body": "This user is not registered. Next time, a different person might be using this nickname.",
  "understand_and_add": "I understand, add",
  "add_to_favorites": "Add to favorites",
  "remove_from_favorites": "Remove from favorites",
  "keep_in_favorites": "Keep in favorites",
  "favorite_warning": "Warning! Click for details",
  "favorite_user": "In favorites",
  "favorites_limit_exceeded": "Favorites limit exceeded",
  "favorites_guest_requires_premium": "Adding guest entries is only available with active Premium",
  "favorites_already_exists": "User is already in favorites",
  "favorites_cannot_add_self": "You cannot add yourself to favorites",
  "favorites_only_for_registered": "This feature is only available for registered users",
  "chat_title": "Sex chat",
  "partners_title": "Our partners",
  "login_title": "Login",
  "chat_long_title": "Free Virtual Sex Chat - explore your fantasies without registration",
  "site_description": "Explore your wildest fantasies at virtual sex chat! Our virtual sex chat platform offers a seamless, registration-free experience where you can communicate and connect with others. Share photos and GIFs while easily discovering free girls and guys online. Join us today for an unforgettable virtual experience!",
  "site_keywords": "virt sex, adult chat, online chat, free sex chat, free sex room, anonymous chat, sex chat, chatroom, sexting, sex chat room, free online adult chat, meet-in-chat, 321sex-chat",
  "yes_change_region": "Yes, change",
  "no_dont_touch_region": "No",
  "registration_confirmation": "Registration confirmation:",
  "email_confirmed": "Your email is verified, you can enter the chat room",
  "link_is_wrong": "The link you followed is wrong. Try again from the very beginning.",
  "email_confirmation": "Email Confirmation",
  "registration": "Registration",
  "create_a_nickname": "Create a username",
  "nickname_is_busy": "The username is already in use, make up another one.",
  "access_restoration": "Access Restoration:",
  "create_a_password": "Choose a password",
  "hide_show_password": "Hide/Show password",
  "fill_in_a_password": "Enter your password",
  "password_to_long": "The password is too long",
  "password_to_short": "The password is too short",
  "password_only_from_digits": "Password must contain at least one letter",
  "repeat_the_password": "Repeat the password",
  "wrong_password": "The password is wrong",
  "password_not_equals": "The passwords do not match",
  "legal_age_confirmation": "I confirm that at the time of registration I have reached the age of 18",
  "confirmation_required": "Confirmation required",
  "confirmation_rules_1": "I confirm that I have read the",
  "confirmation_rules_2": "rules",
  "confirmation_rules_3": "and will abide by them",
  "register": "Register",
  "continue": "Continue",
  "home": "Home",
  "access_restored_you_can_enter_with_new_password": "Access restored, you can now log in with the new password",
  "entrance": "Log in",
  "registration_complete": "Registration completed successfully. Please check your email to continue. If you don't see the email, check your spam folder",
  "access_restoration_step_2": "Restore access (step 2)",
  "access_restoration_step_1": "Restore access (step 1)",
  "email_with_confirmation_link_will_be_send": "You will receive a confirmation email",
  "email_has_already_registered": "This email is already registered",
  "email_is_incorrect": "Email entered incorrectly or not filled in",
  "repeat_email": "Email (again)",
  "you_should_solve_a_captcha": "You must pass the captcha",
  "region": "Region",
  "region_description": "The choice of region determines the primary language of communication, as well as the server to which you connect. Servers in different regions are not connected to each other",
  "close": "Close",
  "check_internet_connection_and_try_again": "There is an error. Check your Internet connection or try again later",
  "email_instruction": "If your email address is correct you will receive an email with further instructions. Check your email",
  "to_contact_the_administration_write_to_email": "To contact the administration, email us at ",
  "current_email": "support@18sexchat.net",
  "contacts": "Contacts",
  "qa": "Q&A",
  "site_only_for_adult_footer": "This website is intended for persons over the age of 18. If you are under 18 years of age, you must leave this site. By logging in to chat, you are verified to be at least 18 years old and means you agree to the ",
  "site_only_for_adult_footer_rules": "rules",
  "site_only_for_adult_footer_and": " and ",
  "site_only_for_adult_footer_privacy_policy": "privacy policy",
  "home_text": "<h1>Discover the world of communication without limits and restrictions!</h1><p>Sex chat is not only a place where you can fulfill your fantasies, but also a great opportunity to know yourself better! In today's world, where openness and honesty about intimate matters are becoming increasingly important, such platforms play a key role in many people's lives.It is a place where you can talk openly about your fantasies, experiment with new ideas in a <a href=\"/virtual-sex-chat\">virtual sex chat</a> and better understand your needs and preferences. For many people, this becomes an important step towards a more informed and satisfying sex life</p><h2>Sex chat is an incredible experience for every person</h2><p>Participating in a sex chat room helps people feel more confident about their sexual preferences and desires. Being able to openly express their thoughts and feelings without fear of judgment or misunderstanding helps develop inner confidence and self-acceptance. This is especially important for those who have difficulty accepting their sexuality in real life.</p><p>It can also help to refresh the couple's relationship and give it a special zest. You have no idea what fantasies your partner may have, but once you try sex chat, you won't want to leave! Sex chat helps to overcome barriers of shyness and insecurity by providing a space for frank discussions. This builds trust and understanding between partners, which in turn leads to deeper and more emotionally fulfilling relationships.</p><p>Why do users love <a href=\"/sexting\">erotic texting</a>?</p><h2>By choosing our sex chat - you choose complete privacy</h2><p>Your privacy is our top priority. Our platform uses the encryption technology to keep your conversations private. You can explore your fantasies without any worries. Navigating our site is easy and fun. With an intuitive design and easy-to-use features, you can dive right into the action and enjoy all the benefits of our sex chat. You can be assured of complete anonymity when using our <a href=\"/anonymous-chat\">anonymous chat</a> room. Create a unique nickname and start exploring new horizons without fear of being recognized.</p><p>Sign up now and start exploring your fantasies today. Our <a href=\"/free-sex-chat\">free sex chat</a> room is ready to give you unforgettable moments and help you find those who share your passions and desires. Don't miss the opportunity to experience something new and exciting.</p><h2>Advantages of our sex chat:</h2><ul><li>Community: Find like-minded people.</li><li>Simplicity: User-friendly interface.</li><li>Anonymity: Complete confidentiality of your participation.</li></ul>",
  "rules_title": "Rules",
  "rules_header": "Rules for chat 18sexchat.net",
  "rules_p1_1": "The ",
  "rules_p1_2": " Internet portal offers free and voluntary authorization to chat on intimate topics. The user who wants to join the chat room automatically agrees with the described rules and accepts the terms of this agreement.",
  "rules_p2": "After authorization each user of the website is considered by the administration as a physical person who has reached an acceptable age for communication on intimate topics. Persons under 18 years old are obliged to stop using the portal and leave the chat room.",
  "rules_p3": "Authorization on the website is offered on the condition of complete anonymity, the user is solely responsible for the information provided during correspondence",
  "rules_p4": "Intimate portal administration does not force chat participants to talk, does not suggest topics, and is not responsible for visitors' actions or inactions. The portal only provides a technical opportunity for the user to organize their communication. Visitor is solely responsible for all information posted on the website.",
  "rules_p5": "The administration has the right to change the content, design, list of services and so on at any time without warning the user. If the changes made to the website are not satisfactory to the user, the administration strongly recommends to leave the website.",
  "rules_p6": "Intimate chat encourages communication on intimate topics that are not prohibited by law.",
  "rules_p7": "You can post pictures, smiley faces, animations, as long as they do not show children, scenes of murder and violence, sex with animals, and other illegal content.",
  "rules_p8": "Chatting without registration in both general and private chats is allowed. Visitor specifies only a fictitious name and sex.",
  "rules_p9": "It is not forbidden to share experiences and personal data in private messages, if all participants of correspondence agree to it.",
  "rules_p10_1": "On the Internet portal ",
  "rules_p10_2": " it is strictly forbidden and punishable by BAN the following:",
  "rules_p11": "Insults and provocation of chat participants.",
  "rules_p12": "Using the personal information of the interlocutor for any purpose without his/her consent.",
  "rules_p13": "Distribution of personal information (name, surname, phone number, photo, etc.) of people who are not members of the chat room",
  "rules_p14": "Distribution of content that is prohibited by law, namely incest, child pornography, as well as allusions to them (using specific nicknames, using phrases that hint at prohibited topics, etc.).",
  "rules_p14_1": "Distribution of content related to zoophilia.",
  "rules_p15": "It is forbidden to use obscene language (swear words) and obscene expressions in the public chats",
  "rules_p16": "It is forbidden to add photos that may cause disgust, such as copro, pissing, violent acts, and others.",
  "rules_p17": "It is forbidden to post information and pictures of a political nature.",
  "rules_p18": "Mass mailing of advertising messages (spam).",
  "rules_p19": "It is forbidden to create chat rooms whose names hint at forbidden topics or which contain obscene language in their titles",
  "rules_p20": "A user can be blocked for being a member of a room whose name hints at or directly suggests a topic/topics forbidden in this chat room",
  "rules_p21": "It is forbidden to use letters and symbols in the name, which help artificially place the room at the beginning of the list of rooms, while they do not carry any semantic meaning.",
  "rules_p22": "It is not permitted to use statements about religion that may offend or insult other visitors.",
  "rules_p23": "It is forbidden to use the CapsLock key when writing text messages.",
  "rules_p24": "It is forbidden to use any other language than English to communicate in public rooms.",
  "rules_p25": "The website administration is not engaged in moderation of content coming from users and their personal information.",
  "rules_p26": "The website management is not responsible for damages, including indirect, unintentional, and other ones, caused to users as a result of communication within the portal. The website and its administrators are in no way responsible for the honor, dignity and reputation of users.",
  "rules_p27": "The management of the website does NOT provide any information about other users in any form to other people",
  "rules_p28": "In case of violation of the rules the website moderator has the right to reprimand the visitor and warn him or her about a possible BAN.",
  "rules_p29": "Administrators reserve the right to decide whether or not to block user accounts. Ignorance of the provisions spelled out in the user agreement does not exempt the user of intimate chat from liability for violations.",
  "rules_p30": "The rules come into effect from the moment the chat participant logged in and provided login information, and are valid for the entire time he or she spends on the website.",
  "rules_p31_1": "These rules are subject to change at any time without prior notice to site visitors. The current list of rules can be found at ",
  "rules_p31_2": ".",
  "privacy_policy": "Privacy Policy",
  "privacy_policy_for_site": "Privacy Policy",
  "privacy_policy_h3_1": "Introduction",
  "privacy_policy_p1": "The privacy of our visitors is very important to us, and we are committed to protecting it. Our privacy policy describes how we handle personal information.",
  "privacy_policy_h3_2": "Collecting personal information",
  "privacy_policy_p2": "The following types of personal data can be collected, stored and used:",
  "privacy_policy_ul1_1": "Information about your device, including your IP address, browser data, and operating system;",
  "privacy_policy_ul1_2": "Information about your visits and use of this website, including the source of the links, duration of the visit, page views, and how you navigate the website;",
  "privacy_policy_ul1_3": "Information you enter when you create a profile on our website, such as gender, email address;",
  "privacy_policy_ul1_4": "Information regarding anything you purchase, services you use, or transactions you make through our website, including your name, address, phone number, email address, and credit card information;",
  "privacy_policy_ul1_5": "Information contained in any communications you send us via email or through our website, including content and metadata;",
  "privacy_policy_ul1_6": "Any other information you send us.",
  "privacy_policy_p3": "Before disclosing another person's private information to us, you must obtain that person's consent for both the disclosure and processing of that personal information in accordance with this Policy",
  "privacy_policy_h3_3": "Use of personal information",
  "privacy_policy_p4": "We may use your personal information for the following purposes:",
  "privacy_policy_ul2_1": "Administering our website and business;",
  "privacy_policy_ul2_2": "Personalizing our website for you;",
  "privacy_policy_ul2_3": "Enabling you to use the services available on our website;",
  "privacy_policy_ul2_4": "Providing third parties with statistical information about our users (but these third parties will not be able to identify any individual user from this information);",
  "privacy_policy_ul2_5": "Handling inquiries and complaints made by or about you relating to our website;",
  "privacy_policy_ul2_6": "Conducting statistical research",
  "privacy_policy_ul2_7": "Ensuring the security of our website and preventing fraud;",
  "privacy_policy_ul2_8": "Other purposes.",
  "privacy_policy_h3_4": "Data retention and deletion",
  "privacy_policy_p5_1": "The user has the right to have his/her data deleted. The period for which your personal data will be stored: the time necessary to use the data for the main activity of the website and the tracking of statistics. When the use of your data ends, the administration of the website deletes it. You can contact the administration of the site to delete your personal data. The contact address is on the ",
  "privacy_policy_p5_2": "Contacts",
  "privacy_policy_p5_3": "page.",
  "privacy_policy_h3_5": "The security of your personal information",
  "privacy_policy_p6": "We have implemented appropriate technical and organizational security measures to protect the personal information we process. Please note, that we cannot guarantee the complete security of the Internet. Although we take all possible measures to protect your personal information, the transmission of this information over the Internet can present certain risks, and you should only access our website in a secure environment.",
  "privacy_policy_h3_6": "Use of cookies",
  "privacy_policy_p7_1": "We use cookies to display content correctly and to make the Virt-Chat website easy to use. These are small files that are stored on your device. Cookies help the website to remember information about you, such as what language you are using and which pages you have accessed before, so that the website can remember this information next time you visit. They can also make it easier for you to browse the site. You can read more about cookies at ",
  "privacy_policy_p7_2": "there",
  "privacy_policy_p7_3": ". If you wish, you can set your browser to accept or reject cookies yourself. Not accepting cookies may limit the functionality of the website.",
  "privacy_policy_h3_7": "Use of personal data by other services",
  "privacy_policy_p8": "This website uses third-party online services that collect information regardless of us: Google Analytics, Yandex.Metrica, Sentry, RichAds and others. The data they collect may be shared with other services within these organizations, and they may use the data to personalize their own advertising network.  You can read the user agreements of these organizations on their websites. We do not control and are not responsible for the privacy policies and practices of third parties.",
  "privacy_policy_h3_8": "Changes",
  "privacy_policy_p9": "We may update this policy from time to time by posting a new version on our website. You should check this page periodically to make sure you understand any changes to this policy.",
  "privacy_policy_h3_9": "Feedback, final clauses",
  "privacy_policy_p10_1": "You can find administration contacts Virt-Chat on the ",
  "privacy_policy_p10_2": "Contacts",
  "privacy_policy_p10_3": " page regarding the privacy policy. If you disagree with this privacy policy, you may not use the services of Virt-Chat, in this case you must refrain from visiting our website.",
  "attention": "Attention!",
  "are_you_over_18_years_old": "Are you over 18?",
  "yes_it_is_true": "Yes, I turned 18.",
  "not_it_is_not_true": "No, I didn't turn 18.",
  "anonymous_login": "Anonymous Login:",
  "login": "Login",
  "forgot_a_password": "Forgot password?",
  "login_as_invisible": "Log in as invisible",
  "your_gender": "Your gender",
  "choose_a_gender": "Choose your gender",
  "email": "Email",
  "not_receive_confirmation_email": "Did you not receive your email confirmation?",
  "send_email_one_more_time": "Send the email again",
  "or": "or",
  "enter": "Log in",
  "cancel": "Cancel",
  "enter_login": "Enter your login",
  "only_for_18_years_old": "This website is only for those over 18 years of age",
  "understand": "Got it",
  "confirmation_sent_successfully": "The confirmation email has been sent. If you do not see the email, check your spam folder",
  "you_are_blocked": "You are blocked for violating chat rules",
  "you_need_to_wait": "You will be blocked for another {{time}}.",
  "update_available": "We've updated something, you need to update the page for the chat to work properly",
  "reload": "Update",
  "too_much_attempts_for_entrance": "Too many incorrect password attempts, please wait {{time}} before trying again.",
  "add_telegram_username_to_block_title": "Adding telegram username to block",
  "add_telegram_username_to_block_explanation": "Specify username from telegram, you can either with @ in front or without",
  "telegram_username": "Telegram username",
  "telegram_username_successful_added": "Username added successfully",
  "telegram_username_added_error": "Username not found or an error occurred",
  "ban_words_h1": "Adding a new word to the STOP list",
  "ban_words_explanation": "Please be careful with adding new words, do not add frequently used words because then you will block most of the messages. Skype logins, telegrams or phone numbers are great to add",
  "blocked_word": "Blocked word",
  "add": "Add",
  "edit": "Edit",
  "delete": "Delete",
  "user_for_block": "Blocking a user: {{who}}",
  "select_reason_for_blocking": "Select the reason for blocking:",
  "block_for": "Block for:",
  "why_we_are_blocking": "Why are you being blocked?",
  "block": "Block",
  "user_for_deny_entry": "Deny enter to user \"{{login}}\"",
  "reason_not_selected": "Reason not selected",
  "chose_kick_reason": "Choose the reason",
  "kick_user_error": "An error occurred while blocking the user",
  "gender_change": "Gender change",
  "to_change_gender": "Change gender",
  "gender_successfully_changed": "Gender has been changed. Changes will take effect after page reload",
  "about_me": "Change avatar",
  "avatar_presets_title": "Choose an avatar",
  "avatar_upload_button": "Upload your own avatar",
  "avatar_upload_hint": "JPEG, PNG or WEBP, up to 10 MB",
  "avatar_upload_success": "Avatar uploaded successfully",
  "avatar_upload_error": "Failed to upload avatar. Please try again",
  "avatar_remove_button": "Remove avatar",
  "avatar_premium_required": "Uploading your own avatar requires Premium",
  "avatar_token_rate_limited": "Too many avatar upload attempts. Please try again later",
  "avatar_invalid_hash": "Could not recognize the uploaded file. Please try uploading the avatar again",
  "avatar_rate_limited": "Avatar changed too often. Please try again later",
  "password_change": "Password change",
  "password": "Password",
  "new_password": "New password",
  "repeat_new_password": "Repeat new password",
  "to_change_password": "Change Password",
  "password_successfully_changed": "Password has been changed successfully",
  "balance": "Balance",
  "make_payment": "Make a payment",
  "your_balance_has_been_replenished_by": "Your balance has been replenished by {{amount}}",
  "has_been_debited_from_you": "{{amount}} has been debited from you",
  "delete_account": "Delete account",
  "cancel_delete_account": "Cancel account deletion",
  "delete_account_title": "Are you sure you want to delete your account?",
  "delete_account_description": "The account will be deleted 7 days after submitting the request, during which time you will be able to withdraw it. <br> <span class=\"red-color\">After deleting your account, anyone can log in under your login \"{{login}}\", since the account will not be linked to your email and will not be protected by your password</span>",
  "yes_delete_my_account": "Yes, I want to delete my account",
  "application_for_delete_account_accepted": "The request to delete your account has been successfully accepted",
  "application_for_delete_account_canceled": "Account deletion canceled",
  "cancel_delete_account_confirmation": "Are you sure you want to cancel account deletion?",
  "yes_cancel_account_delete": "Yes, cancel deletion",
  "no_delete_my_account": "No, I still want to delete my account",
  "your_account_will_deleted_via": "Your account will be deleted in approximately {{time}}",
  "unknown_error": "Something went wrong, please try again later",
  "add_word_to_block_list": "Add a word to the STOP list",
  "add_telegram_username_to_block": "Add Telegram user for block",
  "add_remove_roles": "Assign/Deselect roles",
  "moderator_section": "Moderator section",
  "sort_alphabet_asc": "Alphabetical (a-z)",
  "sort_alphabet_dsc": "Alphabetically (z-a)",
  "sort_alphabet": "Alphabetically",
  "sort_by_gender": "By gender",
  "sort_by_registered": "Registered",
  "sort_by_guests": "Guests",
  "sound_alerts_settings": "Sound notification settings",
  "users_list_sort": "Sort user list",
  "log_in_log_out_messages": "Login/logout messages for users",
  "add_watermark": "Add watermark",
  "show_images": "Show images",
  "images_display_section": "Image display",
  "images_display_chat": "Sent via chat",
  "images_display_external": "External images",
  "external_images_warning_title": "External images",
  "external_images_warning_body": "Loading external images can reveal your IP address, device details, and other information to the resource owner. Enable this only if you trust the source.",
  "external_images_warning_accept": "I understand the risks, show images",
  "external_images_warning_cancel": "Close",
  "dont_show_again": "Don't show again",
  "disallow_private_messages": "Disallow incoming messages",
  "settings": "Settings",
  "enable_disable_autoscroll": "Enable/disable auto-scroll messages",
  "you_dont_have_any_messages": "You have no new messages",
  "chats_with_non_read_messages": "Chats with unread messages",
  "show_hide_users_list": "Show/hide users list",
  "file_too_large": "File is too big. Max file size 15 MB",
  "cant_send_image": "Failed to send image",
  "cant_read_image_from_device": "Failed to receive image from device",
  "your_complaint_has_been_accepted": "Thank you. Your complaint has been accepted",
  "you_cent_send_message_tou_yourself": "You can't write messages to yourself",
  "you_cant_send_private_messages_in_invisible_mode": "You can't write private messages in \"invisible\"",
  "your_login_example": "YourLogin",
  "notifications_in_lobby": "In the Lobby",
  "notifications_in_other_rooms": "In other rooms",
  "notifications_in_private_messages": "In private messages",
  "notifications_on_replays": "In case of reply (@{{login}})",
  "user_offline_cant_send_message": "User is offline, you cannot send a message",
  "close_room_title": "Closing the room: {{room}}",
  "close_reason": "Reason for closing:",
  "block_room_creator": "Do you want to block the creator of the room?",
  "block_room_members": "Do you want to block all members of the room?",
  "please_use_this_very_carefully": "Please use this option only in the most extreme cases (e.g. pedophilia)",
  "to_block_room_creator_phrase_1": "Block the creator",
  "to_block_room_creator_phrase_2": " and participants",
  "to_block_room_creator_phrase_3": " for:",
  "why_room_is_closing": "Why do you want to close a room?",
  "close_the_room": "Close a room",
  "close_room_confirmation_message": "Are you sure you want to close the room? Note: money is not refunded upon closing the room.",
  "room_closed": "Room closed",
  "about_room": "About",
  "info_about_room": "About {{room}}",
  "creator_colon": "Creator:",
  "moderators_colon": "Moderators:",
  "description_colon": "Description:",
  "chose_blocking_time": "Select a time for blocking",
  "report": "Report",
  "report_reason_child_port_zoo": "Kiddie porn / Zoo",
  "report_reason_member_under_18_yo": "Member is under 18 years old",
  "report_reason_spam": "Spam / Insults etc.",
  "report_reason_commerce": "Services for Money",
  "report_men_in_room_for_women": "A man in a woman's room",
  "creating_room": "Room Creation",
  "room_title": "Name for the room",
  "fill_in_room_title": "Enter room name",
  "room_title_too_short": "Room name is too short or contains illegal characters",
  "room_title_too_long": "Room name is too long",
  "room_title_should_start_from_eng_or_rus_character": "Room name must begin with English or Russian letters",
  "password_if_you_want": "Password, if needed",
  "password_too_long": "Password is too long",
  "password_too_short": "Password is too short",
  "additional_parameters_for_room_creation": "Additionally:",
  "paid_room": "Premium room",
  "paid_room_price": "{{price}} per month",
  "paid_room_description": "Your room, your rules! Become the full owner: set your own guidelines, appoint moderators, and take complete control over access. Create the perfect space for your community.",
  "paid_room_details": "This option allows you to:\n• Become a room administrator\n• Appoint other users as moderators\n• Set rules for room visitors\n• Kick and ban rule-breakers",
  "paid_room_settings": "Room settings",
  "unpaid_room_warning": "Your room '{{roomTitle}}' is not paid and is hidden from users. Please top up your balance.",
  "low_balance_upcoming_charge_warning": "Your room '{{roomTitle}}' will be charged in {{daysLeft}} {{daysPlural}}, but you don't have enough balance. Please top up.",
  "deposit_money": "Deposit",
  "add_moderator": "Assign moderator role",
  "remove_moderator": "Take off moderator role",
  "only_premium_can_be_moderator": "Only a user with premium status can be assigned moderator role",
  "user_not_a_room_moderator": "The user is not a moderator of the room",
  "user_name_should_be_entered_in_full": "The user login must be entered as it appears in the list of users.",
  "moderator_role_has_been_successfully_assigned": "The moderator role has been successfully assigned",
  "moderator_role_has_been_successfully_took_off": "The moderator role has been successfully took off",
  "edit_pinned_message": "Edit pinned message",
  "editing_pinned_message": "Editing a pinned message",
  "allowed_tags": "The following tags are allowed: {{tags}}",
  "preview": "Preview:",
  "changes_successfully_applied": "Changes have been successfully applied.",
  "change": "Change",
  "assign": "Assign",
  "take_off": "Take off",
  "user_not_found": "User not found",
  "user_not_premium": "The user does not have premium status",
  "user_banned": "It is forbidden to make a user a moderator if he is banned",
  "user_already_moderator": "The user is already a moderator of this room",
  "allowed_only_to_registered": "Allowed only to registered",
  "allowed_only_to_registered_error": "Enter is allowed only to registered users",
  "which_gender_can_enter_into_room": "What gender can enter the room?",
  "choose_who_can_enter_into_room": "Choose who can enter the room",
  "create_room_attention": "Attention! If the name of the room does not comply with the rules of the chat - it will be forcibly closed by moderators and the user who created the room will be blocked",
  "create": "Create",
  "warning": "Attention!",
  "loosed_connection_with_server": "Connection to the server is lost. Check your Internet connection",
  "enter_again": "Log in again",
  "message": "Message",
  "type_in_message": "Type in a message",
  "send_message": "Send message",
  "send_image": "Send image",
  "show_hide_emoji": "Show/hide emoji panel",
  "answer": "Reply",
  "block_user": "Block user",
  "block_user_commerce": "Block user (commerce)",
  "block_user_child_porn": "Block user (CP)",
  "block_user_age": "Block user (age)",
  "deny_entry": "Deny entry",
  "remove_message": "Delete message",
  "private_message": "Private",
  "ignore": "Ignore",
  "not_ignore": "Do not ignore",
  "load_image_error": "There should be a picture here, but something went wrong",
  "login_for_search": "Login",
  "enter_login_for_search": "Enter login",
  "find": "Find",
  "user": "User",
  "roles": "Roles:",
  "administrator": "Administrator",
  "role_admin_description": "(can assign roles, block moderators and administrators)",
  "moderator": "Moderator",
  "role_moderator_description": "(can block users, close rooms and delete posts)",
  "save": "Save",
  "failed_to_find_anybody": "Failed to find anyone",
  "something_goes_wrong_try_later": "Something goes wrong, please try again later",
  "roles_changed": "Roles have been successfully changed",
  "for_room_entering_need_password_title": "Enter password to enter the room \"{{room}}\"",
  "fill_in_a_password_for_room_entrance": "Enter password to enter the room",
  "search": "Search",
  "clear_search_field": "Clear search box",
  "rooms": "Rooms:",
  "create_room": "Create a room",
  "users": "Users",
  "error_connect": "Unable to connect. Try again later",
  "error_server": "Something went wrong. Try again later or send us an email",
  "wrong_gender": "Gender is not correct",
  "login_too_short": "Nickname is too short",
  "login_is_used": "This username is already used, please try another one",
  "spaces_not_allowed_in_login": "It is forbidden to use a space in your nickname",
  "you_are_bot": "We have a suspicion you are a bot, and bots are not allowed here!",
  "error_en_ru_chars_together": "It's not allowed to use letters from different languages in the username",
  "error_vpn_used": "We have a suspicion that you are using a VPN or proxy. Disable VPN or proxy and try again.",
  "email_is_busy": "This email is already in use",
  "email_or_code_is_wrong": "The data sent is incorrect or the email has been verified",
  "restore_data_is_wrong": "The data sent is incorrect or access has been restored",
  "restore_code_link_expire": "Link time expired, try again from the beginning.",
  "delay_before_confirmation_send": "The previous email was sent less than 24 hours ago. Wait a moment before trying to resend the email. If you don't find the email, check your spam folder",
  "unknown_user_or_email_confirmed": "User not found or email already verified",
  "email_not_confirmed": "To continue, you need to confirm the email",
  "delay_before_restoration_send": "It has been less than an hour since the last retry. Check your email, and check your spam folder if you were unable to find it.",
  "user_is_blocked": "User is blocked",
  "login_too_long": "Nickname is too long",
  "message_to_long": "Message is too long",
  "email_incorrect": "Email is wrong",
  "incorrect_symbols_in_login": "Invalid characters @ or . were used.",
  "other_incorrect_symbols_in_login": "Invalid characters used",
  "passwords_not_equals": "Passwords do not match",
  "emails_not_equals": "Emails do not match",
  "too_many_attempts_to_change_password": "Too many incorrect password attempts",
  "gender_was_changed_recently": "Gender was recently changed. Please try again in 24 hours",
  "no_privileges": "No permissions to perform the action",
  "room_creating_only_for_registered": "Only registered users can create rooms",
  "you_have_created_too_many_rooms": "You have created too many rooms",
  "not_enough_money": "Not enough money on your account",
  "room_not_paid": "Room is not paid. Access is allowed only for the owner.",
  "room_with_name_already_exist": "A room with the same name already exists",
  "complain": "To complain",
  "room_responsibility_title": "Important Warning",
  "room_responsibility_text": "You are responsible for following the rules in this room. If you see prohibited content — file a complaint immediately: click on the sender's nickname → \"Report\". If a rule violation is found in the room, the room will be closed and ALL participants will be blocked.",
  "room_responsibility_confirm": "I understand and continue",
  "room_responsibility_exit": "Exit room",
  "complaint_reason_child_port_zoo": "Kiddie porn / Zoo",
  "complaint_reason_member_under_18_yo": "Member is under 18 years old",
  "complaint_reason_spam": "Spam / Insults etc.",
  "complaint_reason_commerce": "Services for Money",
  "men_in_room_for_women": "A man in a woman's room",
  "message_blocked": "The message is blocked",
  "to_many_messages": "You are sending too many messages, please slow down.",
  "to_many_images_in_main_chat": "Images can be sent to the Lobby no more than once every {{period}}",
  "not_enough_time_after_login": "Images can be sent to the Lobby no earlier than 5 minutes after entering",
  "user_block_error_first_part": "Failed to block user {{user}} because ",
  "block_error_reason_user_not_found": "user is not found",
  "block_error_reason_user_bot_or_admin": "user is a bot or admin",
  "block_error_reason_unknown_reason": "unknown reason",
  "block_error_reason_you_dont_have_permissions": "you do not have permission to block users",
  "block_error_reason_user_already_warned": "the user has already been warned",
  "user_blocked": "User blocked",
  "user_warned": "User was shown a warning",
  "gender_cant_enter_to_room": "{{gender}} are not allowed into the room",
  "cant_enter_gender_girls": "Girls",
  "cant_enter_gender_boys": "Boys",
  "cant_enter_gender_trans": "Transgenders",
  "blocked_users_list": "Blocked users list",
  "manage_ban_reasons": "Managing ban reasons",
  "theme_section": "Theme",
  "theme_light": "Light",
  "theme_dark": "Dark",
  "theme_system": "System",
  "add_new_reason": "Add New Reason",
  "remove_messages": "Remove messages",
  "no_ban_reasons_configured": "No ban reasons configured",
  "title": "Title",
  "description": "Description",
  "blocking_time": "Blocking Time (hours)",
  "remove_user_messages": "Remove user messages",
  "failed_to_load_ban_reasons": "Failed to load ban reasons",
  "error_loading_ban_reasons": "Error loading ban reasons",
  "title_is_required": "Title is required",
  "blocking_time_hint": "1 to 168 hours",
  "please_check_form_errors": "Please check form errors",
  "ban_reason_saved_successfully": "Ban reason saved successfully",
  "failed_to_save_ban_reason": "Failed to save ban reason",
  "error_saving_ban_reason": "Error saving ban reason",
  "ban_reason_deleted_successfully": "Ban reason deleted successfully",
  "error_deleting_ban_reason": "Error deleting ban reason",
  "confirm_delete_ban_reason": "Confirm delete ban reason",
  "unblock_user": "Unblock user",
  "login_fro_unblock": "Nickname for unblock",
  "unblock": "Unblock",
  "user_unblocked": "User \"{{login}}\" unblocked",
  "blocked_users": "Blocked Users",
  "transactions": "Transactions",
  "no_transactions_found": "No transactions found",
  "date": "Date",
  "failed_to_load_transactions": "Failed to load transactions",
  "filter_by_username": "Filter by username",
  "reason": "Reason",
  "will_be_unblocked": "Will Be Unblocked",
  "permanently_banned_users_not_shown": "Permanently banned users are not shown in the list",
  "connection_restored_after_disconnection": "Chat connection restored after disconnection",
  "user_disallow_private_messages": "The user disallow send him private messages",
  "you_disallow_private_messages": "You were disallow private messages",
  "moderator_cant_disable_private_messages": "Moderators cannot disable private messages",
  "too_many_registrations_from_ip": "We have detected too many attempts to register with your IP address",
  "kicked_from_room": "You have been banned from entering the room \"{{room}}\"",
  "kicked_from_room_error": "Moderators of the room \"{{room}}\" have banned you from entering",
  "nothing_found": "Nothing found",
  "would_you_like_to_send_an_image_to_chat": "Would you like to send an image to chat?",
  "yes_send": "Yes, send",
  "chat_moderators": "Chat Moderators",
  "managing_moderators": "Managing moderators",
  "permissions_count": "permissions",
  "permission_add_remove_moderators": "Manage Moderators",
  "permission_edit_pinned_message": "Edit room description",
  "permission_edit_ban_reasons": "Edit Ban Reasons",
  "permission_unblock_users": "Unblock Users",
  "permission_edit_room_password": "Manage room password",
  "room_password": "Room password",
  "new_room_password": "New password",
  "set_room_password": "Set",
  "remove_room_password": "Remove password",
  "room_password_hint": "The password applies to new entries only. Those already in the room will stay, and room moderators enter without a password.",
  "room_password_changed": "Room password changed",
  "room_password_removed": "Room password removed",
  "permission_admin": "Administrator",
  "permission_moderator": "Can block users",
  "no_moderators_found": "No Moderators Found",
  "moderator_permissions_updated": "Moderator permissions updated",
  "error_updating_permissions": "Error updating permissions",
  "moderator_removed_successfully": "Moderator successfully removed",
  "error_removing_moderator": "Error removing moderator",
  "confirm_remove_moderator": "Are you sure you want to remove moderator {{login}}?",
  "username": "Username",
  "select_permissions": "Select Permissions",
  "username_required": "Username is required",
  "exit": "Exit",
  "exit_prompt": "Do you really want to exit?",
  "exit_yes": "Yes, exit",
  "yes": "Yes",
  "no": "No",
  "lobby_room": "Lobby",
  "admins_room": "Admins room",
  "block_list_room": "Blocks list",
  "amount_is_to_small": "The amount is too small",
  "amount_is_to_high": "The amount is too high",
  "payment_initialization_error": "Payment initialization error",
  "payment_error": "Payment error",
  "service_phrases": {
    "enter": {
      "male": "{{login}} has entered the chat",
      "female": "{{login}} has entered the chat"
    },
    "exit": {
      "male": "{{login}} has left the chat",
      "female": "{{login}} has left the chat"
    }
  },
  "ok": "Ok",
  "sex": {
    "female": "Female",
    "male": "Male",
    "trans": "Transgender",
    "girls": "Girls",
    "boys": "Guys",
    "shemales": "Transgenders"
  },
  "days": {
    "zero": "days",
    "one": "day",
    "two": "days",
    "few": "days",
    "many": "days",
    "other": "days"
  },
  "hours": {
    "zero": "hours",
    "one": "hour",
    "two": "hours",
    "few": "hours",
    "many": "hours",
    "other": "hours"
  },
  "minutes": {
    "zero": "minutes",
    "one": "minute",
    "two": "minutes",
    "few": "minutes",
    "many": "minutes",
    "other": "minutes"
  },
  "seconds": {
    "zero": "seconds",
    "one": "second",
    "two": "seconds",
    "few": "seconds",
    "many": "seconds",
    "other": "seconds"
  },
  "blog_title": "Blog",
  "back_to_blog": "Back to blog",
  "make_payment_dialog_title": "Payment",
  "amount_label": "Amount",
  "placeholder_example": "e.g., 10",
  "hint_min_max": "Minimum {{min}}, maximum {{max}}",
  "error_required": "Enter the amount",
  "error_integer": "Enter an integer",
  "error_min": "Minimum amount is {{min}}",
  "error_max": "Maximum amount is {{max}}",
  "pay": "Pay",
  "pay_with_telegram_stars": "Pay with Telegram Stars",
  "pay_with_crypto": "Pay with cryptocurrency",
  "choose_payment_method": "Choose a payment method",
  "back": "Back",
  "choose_telegram_stars_package": "Choose a top-up package",
  "telegram_stars_package_option": "{{units}} units — {{stars}} ⭐",
  "telegram_stars_opening_bot": "Opening Telegram: confirm the payment in the bot",
  "telegram_package_not_found": "This package is no longer available, please choose again",
  "telegram_only_for_registered": "Paying with Telegram Stars is only available to registered users",
  "telegram_stars_disabled": "Paying with Telegram Stars is temporarily unavailable",
  "premium": "Premium",
  "buy_premium": "Premium",
  "premium_benefits": "Premium Benefits",
  "premium_benefit_1": "Golden crown next to your nickname",
  "premium_benefit_2": "Priority in the user list",
  "premium_benefit_3": "Zero ads — enjoy chatting without any interruptions or banners",
  "premium_benefit_4": "Your privacy, your rules — disable private messages at any time",
  "premium_benefit_5": "Increased limits for messages and images in the Lobby",
  "premium_benefit_6": "Favorites without limits — add even anonymous users so you never lose track of them",
  "premium_benefit_7": "Custom avatar — upload any image instead of the preset options",
  "premium_benefit_8": "And this is just the beginning! We are constantly working on new exclusive features for our premium users.",
  "premium_price_for_month": "Price for 1 month:",
  "buy_now": "Buy now",
  "premium_purchased_success": "Premium successfully purchased!",
  "buy_premium_disabled": "Buying premium is temporarily disabled",
  "premium_only_for_registered": "Premium purchase is only available for registered users",
  "premium_until": "Premium until {{date}}",
  "your_premium_active_until": "Your premium is active until: {{date}}",
  "extend_premium": "Extend premium",
  "boost_in_users_list": "Boost in the user list",
  "premium_only_feature": "This feature is only available for premium users",
  "premium_upsell_reminder": "Premium unlocks extra chat features",
  "disable_private_messages": "Disable private messages"
}